//====================================================
//  Initialization Slider
//====================================================
function fn_components_slider(){
	fn_main_slider();
  fn_testimonials_slider();
	fn_gallery_slider();
}



function fn_main_slider(){
	if ($('.js-main-slider-image').length) {
		$('.js-main-slider-image').slick({
			infinite: true,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 2000,
			cssEase: 'linear',
			speed: 500,
      fade: true,
      variableWidth: false,
      mobileFirst: true,
      asNavFor: '.js-main-slider-text',
      nextArrow: '<span class="slick-arrows slick-next"><i class="icon icon-chevron-thin-right"></i></span>',
      prevArrow: '<span class="slick-arrows slick-prev"><i class="icon icon-chevron-thin-left"></i></span>'
    });
  }   
  if ($('.js-main-slider-text').length) {
    $('.js-main-slider-text').slick({
      infinite: true,
      dots: false,
      slidesToShow: 1,
      asNavFor: '.js-main-slider-image',
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      autoplay: false,
      autoplaySpeed: 2000,
      cssEase: 'linear',
      speed: 500,
      variableWidth: false,
      mobileFirst: true,
      nextArrow: '<span class="slick-arrows slick-next"><i class="icon icon-chevron-thin-right"></i></span>',
      prevArrow: '<span class="slick-arrows slick-prev"><i class="icon icon-chevron-thin-left"></i></span>'
    });
  }    
}

function fn_testimonials_slider(){
  if ($('.js-testimonials-slider').length) {
    $('.js-testimonials-slider').slick({
      infinite: true,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 2000,
      cssEase: 'linear',
      speed: 500,
      variableWidth: false,
      mobileFirst: true,
      nextArrow: '<span class="slick-arrows style-2 slick-next"><i class="icon icon-chevron-thin-right"></i></span>',
      prevArrow: '<span class="slick-arrows style-2 slick-prev"><i class="icon icon-chevron-thin-left"></i></span>'
    });
  }    
}



function fn_gallery_slider(){
    if ($('.js-slider-gallery').length) {
        $('.js-slider-gallery').slick({
            infinite: true,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 1500,
            cssEase: 'linear',
            speed: 300,
            variableWidth: false,
            mobileFirst: true,
            nextArrow: '<span class="slick-arrows style-1 slick-next"><i class="icon icon-chevron-thin-right"></i></span>',
            prevArrow: '<span class="slick-arrows style-1 slick-prev"><i class="icon icon-chevron-thin-left"></i></span>',
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                  }
                },
                {
                  breakpoint: 900,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                  }
                },
                {
                  breakpoint: 500,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                  }
                }
            ]
        });
    }
}
